stimulusApp.register(
  "prefetch-lazy",
  class extends Stimulus.Controller {
    static values = {
      root: { type: String },
      rootMargin: { type: String, default: "0px 0px 500px 0px" },
    }

    connect() {
      if (this.element.getAttribute("loading") == "lazy") {
        this.observer = new IntersectionObserver(this.intersect, {
          root: this.rootValue ? document.querySelector(this.rootValue) : null,
          rootMargin: this.rootMarginValue,
        })
        this.observer.observe(this.element)
      }
    }

    disconnect() {
      this.observer?.disconnect()
    }

    intersect = (entries) => {
      const lastEntry = entries.slice(-1)[0]
      if (lastEntry?.isIntersecting) {
        this.observer.unobserve(this.element)
        if (
          this.element.hasAttribute("busy") ||
          this.element.hasAttribute("complete")
        )
          return

        this.element.setAttribute("loading", "eager")
      }
    }
  },
)
